// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"207":"a970534f","497":"7696f8bf"}[chunkId] + ".chunk.css");